import { takeLatest, select, call, put } from "redux-saga/effects";
import axios from "axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import { requestDefaultJson, 
	callbackStatusDefault,
	callbackDataDefault,
	callbackResolveDefault } from './helpers'

const getCdGatesFromApi = (id,token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/portoes/cd/" + id, {
			method: "GET",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
		})
		.then(response => response.status !== 200 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			if (error.response.status === 404) {
				const response = 404
				reject(response);
			} else {
				reject(error);
				log.info(error);
			}
		});
	});
};

const saveCdGateFromApi = (data, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/portoes/", {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
			data
		})
		.then(response => response.status !== 200 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			const response = error.response.data
			reject(response);
			log.info(error);
		});
	});
};

const updateCdGateFromApi = (data, idPortao, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/portoes/" + idPortao, {
			method: "PUT",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
			data
		})
		.then(response => response.status !== 200 ? reject(response) : response)
		.then(response => response.data)
		.then(response => resolve(response))
		.catch(error => {
			const response = error.response.data
			reject(response);
			log.info(error);
		});
	});
};

const deleteCdGateFromApi = (idPortao, token) => {
	return requestDefaultJson({
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + "/portoes/" + idPortao,
		method: "DELETE",
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
			"Authorization": token,
		}
	}, 
	callbackStatusDefault,
	callbackDataDefault,
	callbackResolveDefault, 
	(resolve, reject) => error => {
		const response = error.response.data
		reject(response);
		log.info(error);
	});
};

//generators
function* getCdGates(payload) {
	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);
	
		const data = yield call(getCdGatesFromApi, payload.id, token);

		yield put({ type: "CD_GATES", payload: data });

	} catch (error) {
		yield put({ type: "CD_GATES", payload: [] });

		log.info(error);
	}

}

function* saveCdGate(payload) {
	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);
		
		const data = yield call(saveCdGateFromApi, payload.data, token);
		
		yield put({ type: "GET_CD_GATES", id: data.idCd});

		yield put({ type: "SET_CD_GATE_SUCCESS", payload:{ success: true, type: "save" }});

	} catch (error) {
		
		yield put({ type: "GET_CD_GATES", id: payload.data.idCd});

		yield put({ type: "SET_CD_GATE_ERROR", payload:{ error: true, data: error }});

		log.info(error);
	}
}


function* updateCdGate(payload) {
	try {
		const { token } = yield select(state => state.authentication);
	
		yield call(updateCdGateFromApi, payload.data, payload.data.id, token);

		yield put({ type: "GET_CD_GATES", id: payload.data.idCd});

		yield put({ type: "SET_CD_GATE_SUCCESS", payload:{ success: true, type: "update" }});

	} catch (error) {
			
		yield put({ type: "GET_CD_GATES", id: payload.data.idCd});
		
		yield put({ type: "SET_CD_GATE_ERROR", payload:{ error: true, data: error }});

		log.info(error);
	}
}

function* deleteCdGate({payload}) {
	try {
		const { token } = yield select(state => state.authentication);
		
		yield call(deleteCdGateFromApi, payload.gate.id, token);

		yield put({ type: "SET_CD_GATE_SUCCESS", payload:{ success: true, type: "delete" }});

		yield put({ type: "GET_CD_GATES", id: payload.cdId});

	} catch (error) {
			
		yield put({ type: "GET_CD_GATES", id: payload.cdId});
		
		yield put({ type: "SET_CD_GATE_ERROR", payload:{ error: true, data: error }});

		log.info(error);
	}
}

// //Generator function
export function* getCdGatesWatcher() {
	yield takeLatest("GET_CD_GATES", getCdGates);
	yield takeLatest("SAVE_CD_GATE", saveCdGate);
	yield takeLatest("UPDATE_CD_GATE", updateCdGate);
	yield takeLatest("DELETE_CD_GATE", deleteCdGate);
}
